import React from "react";
import Button from "./Button";
import { colors, spacing } from "./theme";

export default function PageHeader({
  title,
  subtitle,
  actions
}) {
  return (
    <div style={containerStyle}>
      <div>
        <h1 style={titleStyle}>{title}</h1>

        {subtitle && (
          <p style={subtitleStyle}>
            {subtitle}
          </p>
        )}
      </div>

      {actions && (
        <div style={actionsStyle}>
          {actions}
        </div>
      )}
    </div>
  );
}

const containerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: spacing.xl,
  marginBottom: spacing["2xl"],
  flexWrap: "wrap"
};

const titleStyle = {
  margin: 0,
  fontSize: 34,
  fontWeight: 800,
  color: colors.text
};

const subtitleStyle = {
  marginTop: 8,
  marginBottom: 0,
  color: colors.textMuted,
  fontSize: 15,
  maxWidth: 700,
  lineHeight: 1.6
};

const actionsStyle = {
  display: "flex",
  gap: spacing.md,
  alignItems: "center"
};